import { useMemo } from "react";
import apiClient from "./apiClient";
import { MonitoringSnapshot } from "../state/types";

interface MonitoringSnapshotResponse {
  snapshots?: MonitoringSnapshot[];
}

const useMonitoringApi = () => {
  return useMemo(
    () => ({
      getMonitoringSnapshots: async (): Promise<MonitoringSnapshot[]> => {
        try {
          const response = await apiClient.get("/snapshot");
          const data = response.data as MonitoringSnapshot | MonitoringSnapshotResponse;

          if (Array.isArray((data as MonitoringSnapshotResponse).snapshots)) {
            return (data as MonitoringSnapshotResponse).snapshots ?? [];
          }

          return [data as MonitoringSnapshot];
        } catch (e: any) {
          console.log("Could not fetch monitoring snapshot: " + e.toString());
          return [];
        }
      },
      getMonitoringSnapshot: async (hostname?: string): Promise<MonitoringSnapshot | undefined> => {
        const snapshots = await (async () => {
          try {
            const response = await apiClient.get("/snapshot");
            const data = response.data as MonitoringSnapshot | MonitoringSnapshotResponse;

            if (Array.isArray((data as MonitoringSnapshotResponse).snapshots)) {
              return (data as MonitoringSnapshotResponse).snapshots ?? [];
            }

            return [data as MonitoringSnapshot];
          } catch (e: any) {
            console.log("Could not fetch monitoring snapshot: " + e.toString());
            return [];
          }
        })();

        if (!hostname) {
          return snapshots[0];
        }

        return snapshots.find((snapshot) => {
          const snapshotHostname = snapshot.host?.hostname || snapshot.hostname || snapshot.summary?.hostname;
          return snapshotHostname === hostname;
        });
      },
    }),
    []
  );
};

export default useMonitoringApi;
